declare namespace $ {

	export class $mol_icon_camera extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=camera.view.tree.d.ts.map